/**
 * "¿Olvidaste tu contraseña?" (enlazada desde `Login.tsx`): pide el correo y siempre muestra la
 * misma confirmación, exista o no una cuenta con ese correo (mismo criterio que `POST
 * /operators/forgot`, que responde igual en ambos casos).
 */
import { useState, type FormEvent, type ReactElement } from "react";
import { Link } from "react-router-dom";

import { requestOperatorPasswordReset } from "../api/passwordReset";
import { Field } from "../components/Field";
import { toDisplayMessage } from "../lib/errors";

export function ForgotPassword(): ReactElement {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await requestOperatorPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(toDisplayMessage(err));
    } finally {
      setSubmitting(false);
    }
  }

  if (sent) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <h1>Revisa tu correo</h1>
          <p className="login-subtitle">
            Si {email} pertenece a un operador, enviamos un enlace para elegir una contraseña nueva. Vence en poco
            tiempo, así que revísalo pronto.
          </p>
          <Link className="login-forgot-link" to="/login">
            Volver a iniciar sesión
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={(event) => void handleSubmit(event)} noValidate>
        <h1>¿Olvidaste tu contraseña?</h1>
        <p className="login-subtitle">Escribe tu correo y te enviamos un enlace para elegir una nueva.</p>

        <Field label="Correo electrónico">
          {(props) => (
            <input
              {...props}
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          )}
        </Field>

        {error && (
          <p className="field-error" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="button-primary button-block" disabled={submitting}>
          {submitting ? "Enviando…" : "Enviar enlace"}
        </button>

        <Link className="login-forgot-link" to="/login">
          Volver a iniciar sesión
        </Link>
      </form>
    </div>
  );
}
